import { AxiosResponse } from 'axios'
import { ContentType } from '@/enums/http'
import request from '@/utils/request'
import type {
  BatchUpdateRoleRes,
  AccountListFilter,
  AccountListParams,
  AccountListResponse,
  AccountStatusParams,
  RoleParams,
  Role,
  IdParams,
  RoleIdParams,
  RolePermission,
  RoleListResponse,
  RoleNameItem,
  GetUserResponse,
  Chacode,
  GetRoleList,
  GeParentUserList,
  GeParentUserListResponse,
  EditUserParams,
  AddUser,
  ChangeBeLoginRc,
  ImportBusinessUpperResponse,
  BusinessTypeItem,
  SRMRoleData,
  UpdateSrmRoleParams,
  DeleteSrmRoleParams,
  AddSRMRoleParams
} from './model.d'

export function getSRMRoleList() {
  return request.post<SRMRoleData[]>({
    url: '/role/roleConfigList'
  })
}

export function updateSRMRole(data: UpdateSrmRoleParams) {
  return request.post({
    url: '/role/editRoleConfig',
    data
  })
}

export function deleteSRMRole(params: DeleteSrmRoleParams) {
  return request.post({
    url: '/role/delRoleConfig',
    params
  })
}

export function addSRMRole(data: AddSRMRoleParams) {
  return request.post({
    url: '/role/addRoleConfig',
    data
  })
}

// 【谢运鹏】-用户列表
export function getAccountList(data: AccountListParams) {
  return request.post<AccountListResponse>({
    url: '/user/userList',
    data
  })
}
/**
 * 账号管理导出列表
 * @param data 请求参数
 * @backend 吴晓军
 */
export function exportUserList(data: AccountListFilter) {
  return request.request<AxiosResponse<Blob>>(
    {
      url: '/user/exportUserList',
      method: 'POST',
      data,
      responseType: 'blob'
    },
    {
      isReturnNativeResponse: true
    }
  )
}

// 【谢运鹏】-获取用户信息
export function getUser(data: IdParams) {
  return request.post<GetUserResponse>({
    url: '/user/getUser',
    data
  })
}

// 【谢运鹏】-启用/禁用账号
export function changeAccountStatus(data: AccountStatusParams) {
  return request.post({
    url: '/user/changeAccountStatus',
    data
  })
}

// 【余常伟】-新增账号，版本号为v100
export function addUserAccount(data: AddUser) {
  return request.post(
    {
      url: '/user/addUser',
      data
    },
    {
      isTransformResponse: false
    }
  )
}

// 【谢运鹏】-编辑账户
export function updateUserAccount(data: EditUserParams) {
  return request.post(
    {
      url: '/user/editUser',
      data
    },
    {
      isTransformResponse: false
    }
  )
}

// 【余常伟】-新增角色
export function addRole(data: RoleParams) {
  return request.post<boolean>({
    url: '/role/addRole',
    data
  })
}

// 【余常伟】-删除角色
export function delRole(params: { roleId: number }) {
  return request.delete<string>({
    url: '/role/delRole',
    params
  })
}

// 【谢运鹏】-编辑角色
export function editRole(data: RoleParams) {
  return request.post<string>({
    url: '/role/editRole',
    data
  })
}

// 【谢运鹏】-获取角色
export function getRole(data: IdParams) {
  return request.post<Role>({
    url: '/role/getRole',
    data
  })
}

// 【余常伟】-根据角色id查询权限树
export function getRolePermission(params: RoleIdParams) {
  return request.get<RolePermission[]>({
    url: '/role/getRolePermission',
    params
  })
}

// 【余常伟】-根据角色id查询权限树
export function getRoleList(params: GetRoleList) {
  return request.get<RoleListResponse>({
    url: '/role/roleList',
    params
  })
}

//【余常伟】-修改权限配置
export function setRolePermission(data: { menuIdList: number[]; roleId: number }) {
  return request.put({
    url: '/role/setRolePermission',
    data
  })
}

//【谢运鹏】-角色名称下拉列表
export function getRoleNameList() {
  return request.post<RoleNameItem[]>({
    url: '/role/roleNameList'
  })
}

/**【吴晓军】- 选择角色的下拉列表 */
export function roleNameListForUserEdit() {
  return request.post<RoleNameItem[]>({
    url: '/role/roleNameListForUserEdit'
  })
}

// 【谢运鹏】-角色大类名称列表
export function roleTypeNameList() {
  return request.post<string[]>({
    url: '/role/roleTypeNameList'
  })
}

// 【吴晓军】-获取图片验证码
export function captcha() {
  return request.post<Chacode>({
    url: '/user/captcha'
  })
}
/**
 * 获取直接上级(商务跟进人)
 * @backend 吴晓军
 */
export function geParentUserList(params: GeParentUserList) {
  return request.post<GeParentUserListResponse>({
    url: '/user/geParentUserList',
    params
  })
}

/**
 * 设置账户是否灰度测试
 * @param params 请求参数
 * @backend 甘楚雄
 */
export function changeBeLoginRc(data: ChangeBeLoginRc) {
  return request.post({
    url: '/user/changeBeLoginRc',
    data
  })
}

/**
 * 账号管理-导入商务跟进人
 * @backend 吴晓军
 */
export function importBusinessUpper(data: { file: File }) {
  return request.post<ImportBusinessUpperResponse>({
    url: '/user/importBusinessUpper',
    data,
    headers: {
      'Content-Type': ContentType.FORM_DATA
    }
  })
}

/** 【吴晓军】- 获取业务类型下拉列表 */
export function getBusinessTypeEnum() {
  return request.post<BusinessTypeItem[]>({
    url: '/user/getBusinessTypeEnum'
  })
}

/** 【周杰雄】批量更新角色 - 下载模板 */
export function getBatchEditRoleImportTemplate() {
  return request.request<AxiosResponse<Blob>>(
    {
      url: '/user/getBatchEditRoleImportTemplate',
      method: 'POST',
      responseType: 'blob'
    },
    {
      isReturnNativeResponse: true
    }
  )
}
/** 【周杰雄】批量更新角色 - 上传 */
export function batchImportUserRole(data: { file: File }) {
  return request.uploadFile<BatchUpdateRoleRes>({
    url: '/user/batchImportUserRole',
    data
  })
}
